import * as yup from "yup";

import { checkSINValidity } from "../../common/Common";

export const isEmpty = (value: any) =>
  value === null || value === undefined || value === "";
export const NewAcocuntSetupValidationSchema = yup.object().shape({
  legalName: yup
    .string()
    .required("Legal Name is required")
    .min(1, "Minimum length 1 characters")
    .max(100, "Maximum length 100 characters"),
  addressLine1: yup
    .string()
    .required("Address is required")
    .min(1, "Minimum length 1 characters")
    .max(100, "Maximum length 100 characters"),
  city: yup
    .string()
    .required("City is required")
    .min(1, "Minimum length 1 characters")
    .max(30, "Maximum length 30 characters"),
  province: yup.string().required("Province is required"),
  country: yup.string().required("Country is required"),

  // Issuer
  firstName: yup
    .string()
    .required("First Name is required")
    .min(1, "Minimum length 1 characters required")
    .max(60, "Maximum length 60 characters"),
  lastName: yup
    .string()
    .required("Last Name is required")
    .min(1, "Minimum length 1 characters required")
    .max(60, "Maximum length 60 characters"),
  phone1: yup
    .string()
    .required("Phone is required")
    .min(14, "Minimum length 10 characters"),
  // craBusinessNo: yup.string().required("Business No. is required"),

  craBusinessNo: yup
    .string()
    .test(
      "is-valid-business-number",
      "Invalid Business Number",
      function (value: any) {
        if (!value) {
          return this.createError({
            message: "Business Number is required",
            path: this.path,
          });
        }

        const maxLength = 15;
        const firstNineDigits = value.substring(0, 9);
        const output = checkSINValidity(firstNineDigits);

        if (value.length === maxLength && output % 10 === 0) {
          return true;
        }

        return this.createError({
          message: "Invalid Business Number",
          path: this.path,
        });
      },
    )
    .required("Business No. is required"),

  // BANK

  accountNo: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Bank Account No. is required",
      function (value) {
        const { account1Name, branchTransitNumber, bankFinancialNo } =
          this.parent;
        const anyFilled =
          !isEmpty(account1Name) ||
          !isEmpty(branchTransitNumber) ||
          !isEmpty(bankFinancialNo);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  branchTransitNumber: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Branch / Transit No. is required",
      function (value) {
        const { account1Name, accountNo, bankFinancialNo } = this.parent;
        const anyFilled =
          !isEmpty(account1Name) ||
          !isEmpty(accountNo) ||
          !isEmpty(bankFinancialNo);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  bankFinancialNo: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Bank / Fin Institution No. is required",
      function (value) {
        const { account1Name, accountNo, branchTransitNumber } = this.parent;
        const anyFilled =
          !isEmpty(account1Name) ||
          !isEmpty(accountNo) ||
          !isEmpty(branchTransitNumber);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),
});
